import * as trackingFuncs from './tracking';
import * as fetchingFuncs from './fetching';

export const analyticsService = {
  ...trackingFuncs,
  ...fetchingFuncs,
};

export default analyticsService;
export * from './types';
